import React, { useState } from 'react';
import styles from './bowtie-meatball-menu.scss';
import { withCallsToActions } from 'app/area/case/features';
import { HeaderPanelProps } from 'app/components';
import { AddNewConnectedCasesDropdown } from 'app/components/add-new-cases-dropdown/add-new-connected-cases-dropdown';
import { AddNewConnectedCasesWireData } from 'app/area/case/features/calls-to-actions/types';
import { useSharedState } from 'app/infrastructure/redux/hooks';
import { UserType } from 'app/types-shared';
import { MeatballMenu } from 'ui/common/dropdown-menu/meatball-menu';
import { ConnectExistingCases } from 'app/components/connect-existing-cases/connect-existing-cases';
import { useConnectedCases } from 'app/area/bowtie/dropdown/bowtie-meatball-menu-hooks';
import { Favourite } from 'app/area/favourite/favourite';
import { BowtieTranslation } from 'app/area/bowtie/constants';

interface BowtieMeatballMenuProps {
  caseId: number;
  callsToActions?: HeaderPanelProps['callsToActions'];
  loadConnectedCases: (caseNumber: number, connectionType: number) => void;
  translation: BowtieTranslation;
  onChangeCaseConnection?: (params: {
    caseId: number; connectionType: number; connectedCaseId: number; bowtie: boolean;
    instanceKey: string;
  }) => void;
  stateForCaseIds: { [caseId: string]: { valid: boolean; fetching: boolean } };
}

export const BowtieMeatBallMenuContainer = (props: BowtieMeatballMenuProps) => {
  const { caseId, callsToActions: fetchCallsToActions, translation, onChangeCaseConnection } = props;
  const [callsToActions, setCallsToActions] = useState(undefined);
  const sharedState = useSharedState();
  const allowForCurrentUser = sharedState?.userType?.v !== UserType.basic;
  const connectionTypes = callsToActions?.connectExistingCases?.options?.map(o => o.v) || [];
  const { connectedCasesByConnectionType, instanceKey, updateBowtieInstance, validateCaseId } = useConnectedCases(caseId, connectionTypes);
  const onExpandMenu = async () => {
    if (caseId) {
      const options = await fetchCallsToActions(caseId);
      setCallsToActions(options);
    }
  };

  const changeCaseConnection = async (params) => {
    const response = await onChangeCaseConnection({...params, bowtie: true, instanceKey});
    updateBowtieInstance(instanceKey, caseId, connectionTypes);
    return response;
  };

  const renderDropdown = <div className={styles.bowtiedropdownContent}>
    <ul>
      {allowForCurrentUser &&
        callsToActions?.addNewConnectedCases?.map((addNewConnectedCase: AddNewConnectedCasesWireData, index: number) => {
          return <AddNewConnectedCasesDropdown
            entityId={caseId}
            addNewConnectedCaseButtons={addNewConnectedCase.newCaseButtons}
            textLabelMenu={addNewConnectedCase.label}
            key={index}
          />;
        })}
      {(callsToActions?.connectExistingCases && callsToActions?.editAccess) && connectedCasesByConnectionType &&
        <ConnectExistingCases
          {...translation}
          {...props}
          caseId={caseId}
          options={callsToActions.connectExistingCases?.options}
          label={callsToActions.connectExistingCases?.label}
          connectedCasesIdsByConnectionType={connectedCasesByConnectionType}
          allowWarnings={false}
          searchEnabled
          favouriteComponent={Favourite}
          onChangeCaseConnection={changeCaseConnection}
          onCloseCallback={() => updateBowtieInstance(instanceKey, caseId, connectionTypes)}
          disconnectWarning
          validateCaseId={(caseIdToConnect) => validateCaseId(instanceKey, caseIdToConnect)}
        />
      }
    </ul>
  </div>;

  return (
    <MeatballMenu onExpandMenu={onExpandMenu}>
      {renderDropdown}
    </MeatballMenu>
  );
};
export const BowtieMeatBallMenu = withCallsToActions(BowtieMeatBallMenuContainer);
